export default __webpack_public_path__ + "static/media/Shrine to Music.93ef1945.png";